import { createSlice } from "@reduxjs/toolkit";

const date = new Date();
let formatDate = date.toDateString();
// console.log(`date generated in calendar slice: ${formatDate}`)

const initialState = {
  selectedDate: formatDate,
  isDateSelected: false,
  doctorId: 0,
  consultationMode: 1,
  leadId: 0,
  callerName: "",
  callerPhoneNumber: "",
  patientName: "",
  paymentMode: "online",
  bookingConfirmationInfo: {},
};

const calendarWidgetSlice = createSlice({
  name: "calendarWidget",
  initialState,
  reducers: {
    updateCalendarWidgetDate: (state, action) => {
      state.selectedDate = action.payload.finalAppointmentDate;
      state.isDateSelected =
        action.payload.finalAppointmentDate !== "" ? true : false;
    },
    updateDoctorID: (state, action) => {
      state.doctorId = action.payload.doctorId;
    },
    updateConsultationMode: (state, action) => {
      state.consultationMode = Number(action.payload.consultationMode);
    },
    updateLeadId: (state, action) => {
      state.leadId = action.payload.leadId;
    },
    updateCallerDetails: (state, action) => {
      state.callerName = action.payload.callerName;
      state.callerPhoneNumber = action.payload.CallerPhoneNumber;
    },
    updatePatientDetails: (state, action) => {
      if (state.servicefor === "yourself") {
        state.patientName = state.callerName;
      } else {
        state.patientName = action.payload.patientName;
      }
    },
    updateServicefor: (state, action) => {
      state.servicefor = action.payload.servicefor;
    },
    updatePaymentMode: (state, action) => {
      state.paymentMode = action.payload.paymentMode;
    },
    updateBookingConfirmationInfo: (state, action) => {
      state.bookingConfirmationInfo = action.payload;
    },
  },
});

export const {
  updateCalendarWidgetDate,
  updateDateSelectionStatus,
  updateConsultationMode,
  updateDoctorID,
  updatePaymentMode,
  updateServicefor,
  updateBookingConfirmationInfo,
} = calendarWidgetSlice.actions;

export default calendarWidgetSlice.reducer;
